import {
  ArticleHeaderSVG,
  ChecklistSVG,
  FolderHollowSVG,
  PaperHollowSVG,
  type SvgComponentType,
  VideoSVG,
} from "@newsela/angelou";

export const excludedTypes = ["audiotrack", "video"];

export const contentTypeSvgMap: Record<string, SvgComponentType> = {
  articleheader: ArticleHeaderSVG,
  externallink: PaperHollowSVG,
  interactivevideolink: VideoSVG,
  standard: ChecklistSVG,
  textset: FolderHollowSVG,
};
